import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { CompaniesTable } from '@/features/admin/CompaniesTable';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin Companies route — platform admin's view of every company + its AI
 * data-use track, with the admin-only control to switch a company non-AI ↔ AI.
 * Thin shell over CompaniesTable (mirrors admin.terms → PublishTermsCard).
 * Bounces to /admin/login if the admin cookie isn't set.
 */
export const Route = createFileRoute('/admin/companies')({
  component: AdminCompaniesPage,
});

function AdminCompaniesPage() {
  useAdminAuthGuard();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="Companies"
        subtitle="Each company’s AI data-use track. Switching re-issues the matching data-use agreement — the company must accept it again before it takes effect, and their prior acceptance stays on record."
      />
      <CompaniesTable />
    </AdminShell>
  );
}
